import { render, staticRenderFns } from "./ApfAfterSubmitMessage.vue?vue&type=template&id=0e3e129a"
import script from "./ApfAfterSubmitMessage.vue?vue&type=script&lang=js"
export * from "./ApfAfterSubmitMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports